
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Blur from 'vux/src/components/blur/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


const CHECK_REG = /^\d+(\.\d+)?$/
const CHECK_ONE = /^[0-9]+$/

export default {
components: {
Blur,
XHeader,
Card,
Divider,
Cell,
CellFormPreview,
CellBox,
Badge,
Group,
Loading,
XTextarea,
XInput,
XSwitch,
XButton,
Toast,
Swiper,
SwiperItem
},
data () {
return {
showToast: false,
goods_status: false,
message: '',
goods_specs_status: 0,
rows: 2,
fontSiz: '14px',
data: {
goods_id: '',
original_img: '',
goods_name: '',
goods_remark: '',
shop_price: '',
market_price: '',
cost_price: '',
store_count: '',
weight: '',
is_on_sale: '',
goods_specs: [],
goods_image_list: [],
goods_image_index: 0
},
checkData: function (val) {
return {
valid: CHECK_REG.test(val), // 此处不能调用 this.checkVal
msg: '格式不正确'
}
},
checkData2: function (val) {
return {
valid: CHECK_ONE.test(val), // 此处不能调用 this.checkVal
msg: '格式不正确'
}
}
}
},
created () {
const goodsId = this.$route.query.goods_id
this.$store.dispatch('getGoodsInfo', goodsId).then((res) => {
this.data = res.data
console.log(this.data)
if (this.data.goods_specs.length) {
this.goods_specs_status = 1
}
if (res.data.is_on_sale === 1) {
this.goods_status = true
}
})
},
methods: {
onChange (val, key, type = 0) {
let pp = 0
if (type === 1) {
this.data.price_rate_config.forEach((r) => {
if (parseFloat(this.data.cost_price) >= parseFloat(r.price_s) &&
parseFloat(this.data.cost_price) <= parseFloat(r.price_e)) {
pp = r.rate
}
})
this.data.show_price.forEach((e) => {
e.cost_price = this.roundValue(this.data.cost_price * (e.g_rate / 100))
e.shop_price = this.roundValueOne((this.data.cost_price * (e.g_rate / 100)) / (1 - this.data.true_rate * pp * e.c_rate / 1000000))
})
}
setTimeout(() => {
if (val && typeof val === 'string') {
this.data[key] = val.replace(/[^\d.]/g, '')



}
}, 0)
},
onChange2 (val, key, index, type = 0) {
let pp = 0
if (type === 1) {
this.data.price_rate_config.forEach((r) => {
if (parseFloat(this.data.goods_specs[index]['spec_cost_price']) >= parseFloat(r.price_s) &&
parseFloat(this.data.goods_specs[index]['spec_cost_price']) <= parseFloat(r.price_e)) {
pp = r.rate
}
})
this.data.goods_specs[index]['show_price'].forEach((e) => {
e.cost_price = this.roundValue(this.data.goods_specs[index]['spec_cost_price'] * (e.g_rate / 100))
e.shop_price = this.roundValueOne((this.data.goods_specs[index]['spec_cost_price'] * (e.g_rate / 100)) / (1 - this.data.true_rate * pp * e.c_rate / 1000000))
})
}
setTimeout(() => {
if (val && typeof val === 'string') {
this.data.goods_specs[index][key] = val.replace(/[^\d.]/g, '')



}
}, 0)
},
roundValue (val) {
return Math.round(val * 100) / 100
},
roundValueOne (val) {
return Math.round(val * 10) / 10
},
checkVal (val) {
return CHECK_REG.test(val)
},
checkOne (val) {
return CHECK_ONE.test(val)
},
editGoods () {
if (this.goods_status) {
this.data.is_on_sale = 1
} else {
this.data.is_on_sale = 0
}
this.data.goods_specs_status = this.goods_specs_status
let reStatus = 1
let textStr = ''
if (!this.data.goods_name) {
reStatus = 0
textStr = '标题不能为空'
} else {
if (this.data.goods_specs_status) {
this.data.goods_specs.forEach((e, index) => {
if (e.spec_cost_price === '') {
reStatus = 0
textStr = '价格不能为空'
return
} else if (!this.checkVal(e.spec_cost_price)) {
reStatus = 0
textStr = '价格格式不正确'
return
}





if (e.store_count === '') {
reStatus = 0
textStr = '库存不能为空'
return
} else if (!this.checkOne(e.store_count)) {
reStatus = 0
textStr = '库存格式不正确'
return
}
if (e.weight === '') {
reStatus = 0
textStr = '重量不能为空'
} else if (!this.checkVal(e.weight)) {
reStatus = 0
textStr = '重量格式不正确'
}
})
} else {
if (this.data.cost_price === '') {
this.$vux.toast.text('价格不能为空')
return
} else if (!this.checkVal(this.data.cost_price)) {
this.$vux.toast.text('价格格式不正确')
return
}











if (this.data.store_count === '') {
this.$vux.toast.text('库存不能为空')
return
} else if (!this.checkVal(this.data.store_count)) {
this.$vux.toast.text('库存格式不正确')
return
}
if (this.data.weight === '') {
this.$vux.toast.text('重量不能为空')
return
} else if (!this.checkVal(this.data.weight)) {
this.$vux.toast.text('重量格式不正确')
return
}
}
}
if (!reStatus) {
this.$vux.toast.text(textStr)
return
}
const goodsId = this.$route.query.goods_id
if (goodsId) {
this.$store.dispatch('goodsEdit', this.data).then((res) => {
this.message = res.msg
this.showToast = true
if (res.status > 0) {
this.$vux.toast.text('修改成功', 'top')
this.$router.push({path: '/goods/goods_list'})
}
})
}
},
onGoodsImageIndexChange (index) {
this.data.goods_image_index = index
}
}
}



// WEBPACK FOOTER //
// ./src/components/goods/GoodsEdit.vue